var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#898F9D",
    width: "64px",
    height: "64px",
    viewBox: "-1 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cf-icon-svg",
    stroke: "#898F9D",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.417 9.579A7.917 7.917 0 1 1 8.5 1.662a7.917 7.917 0 0 1 7.917 7.917zm-2.553-1.176a.282.282 0 0 0 .06-.442l-1.63-1.813a2.05 2.05 0 0 0-1.524-.68h-.68a1.728 1.728 0 0 1-3.177 0h-.68a2.05 2.05 0 0 0-1.523.679L3.075 7.96a.282.282 0 0 0 .061.442l1.117.704a.396.396 0 0 0 .508-.086l.56-.702v5.289a.347.347 0 0 0 .345.345h5.672a.347.347 0 0 0 .346-.345V8.324l.555.697a.396.396 0 0 0 .508.086l1.117-.704z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitModal);
export default __webpack_public_path__ + "static/media/fit-modal.7e98f8c4c72a284fda6c61e6b7e4ee85.svg";
export { ForwardRef as ReactComponent };